export default __webpack_public_path__ + "static/media/wy.06fa937f.png";